module.exports = {"530129001":"仁德街道","530129002":"塘子街道","530129003":"金所街道","530129103":"羊街镇","530129104":"柯渡镇","530129105":"倘甸镇","530129106":"功山镇","530129107":"河口镇","530129108":"七星镇","530129109":"先锋镇","530129110":"鸡街镇","530129111":"凤合镇","530129205":"六哨乡","530129208":"联合乡","530129209":"金源乡","530129210":"甸沙乡","530129405":"昆明倘甸产业园区轿子山旅游开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530129.json
// module id = 2551
// module chunks = 0